import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [ "name", "locale" ];

  initialize() {
    super.initialize();
    this.checkValuesPresence()
  }

  checkValuesPresence() {
    if (this.nameTarget.value.trim() && this.localeTarget.value.trim()) {
      $( "#submit" ).prop( "disabled", false );
    } else {
      $( "#submit" ).prop( "disabled", true );
    }
  }
}